// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3c6Zm","select":"Header_select__2h4Md","clinic":"Header_clinic__2oL69"};